/** Datos de la regla 238 de una operación: CFDI, contenedor, consolidación y mercancía embargada. */
export interface Rule238 {
  /** Número PAMA (puede ser nulo). */
  pama_number:                    string | null;
  /** Folio fiscal del CFDI (puede ser nulo). */
  fiscal_folio_cfdi:              string | null;
  /** Monto total del CFDI (puede ser nulo). */
  total_amount_cfdi:              string | null;
  /** Monto total de la presentación (puede ser nulo). */
  total_amount_presentation:      string | null;
  /** Monto del depósito de mercancía (puede ser nulo). */
  amount_merchandise_deposit:     string | null;
  /** Monto de compensación (puede ser nulo). */
  compensation_amount:            string | null;
  /** Dimensión del contenedor (puede ser nula). */
  container_dimension:            string | null;
  /** Tipo de contenedor (puede ser nulo). */
  container_type:                 string | null;
  /** Número de sellos del contenedor (puede ser nulo). */
  number_container_seals:         string | null;
  /** Número de candados del contenedor (puede ser nulo). */
  number_container_locks:         string | null;
  /** Contenedor sin consolidar (puede ser nulo). */
  unconsolidated_container:       string | null;
  /** Almacén de desconsolidación (puede ser nulo). */
  deconsolidated_store:           string | null;
  /** Medio de transporte sin consolidar (puede ser nulo). */
  unconsolidated_means_transport: string | null;
  /** Contenedor consolidado (puede ser nulo). */
  consolidated_container:         string | null;
  /** Almacén de consolidación (puede ser nulo). */
  consolidated_store:             string | null;
  /** Medio de transporte consolidado (puede ser nulo). */
  consolidated_means_transport:   string | null;
  /** Mercancía embargada por aduana. */
  customs_embargoed_merchandise:  CustomsEmbargoedMerchandise[];
}

/** Datos para crear un registro de regla 238 asociado a una operación. */
export interface Rule238Create extends Rule238 {
  /** Identificador de la operación. */
  operation_id: number;
}

/** Datos para actualizar un registro de regla 238 existente. */
export interface Rule238Update extends Rule238 {
  /** Identificador del registro de regla 238. */
  id: number;
}

/** Respuesta de operaciones sobre la regla 238. */
export interface Rule238Response {
  /** Mensaje descriptivo del resultado. */
  message: string;
  /** Indica si la operación produjo error. */
  error:   boolean;
  /** Identificador del registro afectado (opcional). */
  id?:     number;
}

/** Mercancía embargada por aduana con su oficio, fecha, peso y archivo. */
export interface CustomsEmbargoedMerchandise {
  /** Identificador del registro. */
  id:                           number;
  /** Número de oficio. */
  trade_number:                 string;
  /** Fecha del oficio (ISO 8601). */
  office_date:                  string;
  /** Peso de la mercancía embargada. */
  weight_embargoed_merchandise: number;
  /** Clave/ruta del archivo soporte. */
  file:                         string;
}

/** Datos para actualizar la mercancía embargada de un registro de regla 238. */
export interface UpdateEmbargoedMerchandise {
  /** Identificador del registro de regla 238. */
  id:                             number;
  /** Identificador del último embargo registrado. */
  last_id_embargoed:              number;
  /** Listado de mercancía embargada por aduana. */
  customs_embargoed_merchandise:  CustomsEmbargoedMerchandise[];
}

/** Datos para eliminar un registro de mercancía embargada. */
export interface DeleteEmbargoedMerchandise {
  /** Identificador del registro de regla 238 asociado. */
  rule_register_id: number;
  /** Identificador del embargo a eliminar. */
  id:               number;
}

/** Parámetros para descargar el archivo de una mercancía embargada. */
export interface DownloadFile {
  /** Identificador del embargo. */
  id:               number;
  /** Identificador del registro de regla 238 asociado. */
  rule_register_id: number;
}

/** Respuesta de descarga de archivo de la regla 238. */
export interface FileResponse {
  /** Mensaje descriptivo del resultado. */
  message: string;
  /** Indica si la operación produjo error. */
  error:   boolean;
  /** URL para acceder al archivo. */
  url:     string;
}
